<template>
  <object class="frame" :data="src" :style="frameStyle"></object>
</template>

<script>
export default {
  name: 'PdfDocument',
  props: {
    src: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      default: null,
    },
  },
  computed: {
    frameStyle() {
      return {
        width: 100 + '%',
        height: this.height ? this.height + 'px' : 100 + '%',
      };
    },
  },
};
</script>
